import { CommonSearchInput } from 'components/common/form/search';
import { PITCH_TYPE_FILTER_OPTIONS } from 'enums/filters';
import { PitchType } from 'lib_ts/enums/pitches.enums';
import { useVideosStore } from 'stores/use-videos-store';

interface IProps {
  onChange?: () => void;
}

export const VideosFilterPitchType = (props: IProps) => {
  const filter = useVideosStore((s) => s.filter);

  return (
    <CommonSearchInput
      id="video-type"
      placeholder="common.pitch-type"
      options={PITCH_TYPE_FILTER_OPTIONS}
      values={filter.type}
      onChange={(v) => {
        useVideosStore.getState().mergeFilter({ type: v as PitchType[] });
        props.onChange?.();
      }}
      multiple
      optional
      skipSort
    />
  );
};
